import { render } from "./StepBack.vue?vue&type=template&id=a26aa38a"
import script from "./StepBack.vue?vue&type=script&lang=js"
export * from "./StepBack.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__